<template>
  <div>
    <TopHeader code="study" />

    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link to="" class="item">学习</router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24 col-sm-6">
            <SideUserPanel :model="model" />
            <div class="g-sideMenu">
              <div class="title">学习</div>
              <div class="list">
                <div
                  v-for="(item, index) in leftMenuList"
                  :key="index"
                  class="item"
                  :class="path == item.path ? 'on' : ''"
                  @click="path = item.path"
                >
                  <router-link :to="item.path" v-html="item.name"></router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18">
            <router-view />
          </div>
        </div>
      </div>
    </section>
    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import SideUserPanel from '@/components/SideUserPanel.vue';

export default {
  name: 'StudyLayout',
  components: {
    TopHeader,
    BottomFooter,
    SideUserPanel,
  },
  data() {
    return {
      model: {},
      leftMenuList: [
        { name: '<i class="e">课</i>程', path: '/study/course' },
        { name: '<i class="e">考</i>试', path: '/study/exam' },
        { name: '<i class="e">直</i>播', path: '/study/live' },
        { name: '<i class="e">专</i>题', path: '/study/trainclass' },
        { name: '<i class="e">问</i>卷', path: '/study/questionnaire' },
        // { name: '<i class="e">话</i>题', path: '/study/topic' },
        // { name: '学习地图', path: '/learningmap' },
      ],
      path: this.$route.path.toLowerCase(),
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.path = to.path.toLowerCase();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLearningStatistics();
    },
    async getLearningStatistics() {
      const response = await this.$api.user.getLearningStatistics();
      const data = response.data.data;
      this.model = data;
      this.$store.dispatch('setLearningStatistics', data);
    },
  },
};
</script>
